module.exports = "<div class=\"sv-skeleton-element\" data-bind=\"attr: { id: element.id }\">\n</div>";